import React from 'react';
import Modal from '@mui/material/Modal';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { useDispatch, useSelector } from 'react-redux';
import { selectBillModStatus, setViewBillMod } from '../../Redux/billing';
import ViewBill from '../viewBill';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'min(94vw, 780px)',
  maxHeight: '92vh',
};

export default function ViewBillModal() {
  const dispatch = useDispatch();
  const ModalStatus = useSelector(selectBillModStatus);

  const handleClose = () => {
    dispatch(setViewBillMod(false));
  };

  return (
    <div className="bg-white ">
      <Modal
        open={ModalStatus}
        onClose={handleClose}
        aria-labelledby="invoice-preview-title"
      >
        <div
          style={style}
          className="overflow-hidden rounded-2xl bg-slate-100 shadow-2xl outline-none"
        >
          <div className="flex h-14 items-center justify-between border-b border-slate-200 bg-white px-5">
            <div>
              <div id="invoice-preview-title" className="text-base font-bold text-slate-900">Invoice preview</div>
              <div className="text-xs text-slate-500">Review, share or save this invoice</div>
            </div>
            <button
              type="button"
              onClick={handleClose}
              aria-label="Close invoice preview"
              className="flex h-9 w-9 items-center justify-center rounded-full text-slate-500 transition hover:bg-slate-100 hover:text-slate-900 focus:outline-none focus:ring-4 focus:ring-orange/20"
            >
              <CloseRounded sx={{ fontSize: 22 }} />
            </button>
          </div>
          <ViewBill />
        </div>
      </Modal>
    </div>
  );
}
